<!--  -->
<template>
  <div>
    <!-- 追书云 -->
    <div class="optionbox">
      <div class="optiontext">渠道名称：</div>
      <el-input v-model="name" style="width:300px" placeholder="请输入内容" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广成本：</div>
      <el-input v-model="money" style="width:300px" placeholder="请输入内容" type="number" @blur="activegivemoney" />
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">阅读章节原文：</div>
      <div>{{ zhangjiename }}</div>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">入口页面：</div>
      <div>小说阅读页</div>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">推广类型：</div>
      <el-radio-group v-model="promotionpointradio">
        <el-radio :label="1">微信</el-radio>
        <el-radio :label="2">站外</el-radio>
      </el-radio-group>
    </div>
    <div class="optionbox demo-ruleForm">
      <div class="optiontext">派单类型：</div>
      <el-radio-group v-model="promotiontyperadio">
        <el-radio :label="'EXTERNAL'">外部</el-radio>
        <el-radio :label="'INTERNAL'">内部</el-radio>
      </el-radio-group>
    </div>
    <el-button type="primary" @click="sumbit">确定</el-button>
    <!-- {{ objquery }} -->
  </div>

</template>

<script>
import { createtemplate, bookPlatformcreate } from '@/api/sourceMaterial.js'
export default {
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      objquery: {},
      name: '',
      money: '',
      zhangjiename: '',
      promotionpointradio: 1,
      promotiontyperadio: 'EXTERNAL',

      subscribechapterid: null, // 强关章节id
      subscribechaptername: null, // 强关章节名称
      subscribechapterseq: null// 强关章节号
    }
  },
  watch: {
    obj: {
      handler(newValue, oldValue) {
        // console.log('111', newValue)
        this.objquery = newValue
        this.name = newValue.bookname + '-' + newValue.chaptername
        this.zhangjiename = newValue.chaptername
        if (this.objquery.bookid != null) {
          console.log('1111')
          this.getqiangid()
        }
      },
      deep: true
    }
  },
  created() {
    this.objquery = this.obj
    if (this.objquery.bookid != null) {
      this.getqiangid()
    }
  },
  mounted() {

  },
  methods: {
    activegivemoney() {
      // eslint-disable-next-line eqeqeq
      if (this.money < 0 && this.money != '') {
        this.money = 1
      }
    },
    // 获取强关章节id
    async getqiangid() {
      const data = await createtemplate({
        platform_id: this.objquery.platformvalue,
        novel_id: this.objquery.bookids
      })
      this.subscribechapterid = data.data.book_info.force_subscribe_cid
      this.subscribechaptername = data.data.book_info.force_subscribe_chapter_name
      this.subscribechapterseq = data.data.book_info.force_subscribe_chapter_seq
      console.log('data111book_info', data.data.book_info)
    },
    async sumbit() {
      if (this.objquery.platformvalue === null) {
        this.$message.error('请选择平台')
        return
      }
      if (this.objquery.bookid === null) {
        this.$message.error('请选择书籍')
        return
      }
      if (this.objquery.chapterid === null) {
        this.$message.error('请选择章节')
        return
      }
      if (this.name === '') {
        this.$message.error('请输入渠道名称')
        return
      }
      if (this.money === '') {
        this.$message.error('请输入推广成本')
        return
      }
      const data = await bookPlatformcreate({
        platform_id: this.objquery.platformvalue,
        template_data: {
          promotion_type: this.promotiontyperadio,
          promotion_point: this.promotionpointradio,
          cost: this.money,
          name: this.name,
          channel_type: 'AUTHENTICATED',
          book_name: this.objquery.bookname,
          book_id: this.objquery.bookid,
          chapter_id: this.objquery.chapterid,
          chapter_name: this.objquery.chaptername,
          subscribe_chapter_id: this.subscribechapterid,
          subscribe_chapter_name: this.subscribechaptername,
          subscribe_chapter_seq: this.subscribechapterseq,
          force_show_qrcode: 0,
          company_name: '',
          agent_name: '',
          ad_account: '',
          is_quickapp: 0
        }
      })
      this.$emit('close')
      this.$message({
        message: '添加成功',
        type: 'success'
      })
      console.log('data', data)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.optionbox{
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.optiontext{
  width: 100px;
  text-align: right;
}
.loltext{
  margin-left: 100px;
}
.demo-ruleForm /deep/ .el-input__inner{
  line-height: 1px !important;
}
/**
 * 解决el-input设置类型为number时，去掉输入框后面上下箭头
 **/
.demo-ruleForm /deep/ input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
